function initAccordion(scope) {
    let allAccordions = $(scope).find('.js_accordion');

    $(scope).find('.accordion-header-wrap').off('click').on('click', function (e) {
        e.preventDefault();
        const accordion = $(this).parent();
        const isOpen = accordion.hasClass('open');
        allAccordions.find('.accordion_content').slideUp(300, "swing");
        allAccordions.removeClass('open');
        if (!isOpen) {
            accordion.find('.accordion_content').slideDown(500, "swing");
            accordion.addClass('open');
        }
    });

    let allAccordionsMenu = $(scope).find('.js_accordion_menu');

    $(scope).find('.accordion-header-wrap-menu').off('click').on('click', function (e) {
        e.preventDefault();
        const accordion = $(this).parent();
        const isOpen = accordion.hasClass('open');
        allAccordionsMenu.find('.accordion_content_menu').slideUp(300, "swing");
        allAccordionsMenu.removeClass('open');
        if (!isOpen) {
            accordion.find('.accordion_content_menu').slideDown(500, "swing");
            accordion.addClass('open');
        }
    });
}

$(document).ready(function () {
    // Run on initial page load
    initAccordion(document);
});